import React from 'react';
import { BaseButton, Link } from '@common/components';
import { buildDialogUrl } from '@common/services';
import { DisputeAvailableActionType } from '@pay-bill/graphql';
import { capitalize } from 'lodash';

export const DisputeViewDrawerButton = ({
  disputeCode,
  action,
  label,
}: {
  disputeCode: string;
  action: DisputeAvailableActionType;
  label?: string;
}) => {
  const disputeViewDrawerUrl = buildDialogUrl('dispute-view-drawer', {
    props: { action, disputeCode },
    overlap: false,
  });

  return (
    <Link to={disputeViewDrawerUrl}>
      <BaseButton
        className="dispute-view-button"
        type={['approve', 'accept'].includes(action) ? 'primary' : undefined}
        danger={action === 'reject'}
        size="large"
      >
        {label || capitalize(action)}
      </BaseButton>
    </Link>
  );
};
